// Modified by AI on 06/24/2026. Edit #1.
import { get } from 'lodash';

import React from 'react';
import { withRouter } from 'react-router-dom';
import { matchPath } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import RecruiterHttpService from '../api/RecruiterHttpService';
import { QUERY_KEYS, FIVE_MINUTES_MS } from '../constants/queryKeys';

const RecruiterContext = React.createContext({
    recruiter: null,
});

export const RecruiterContextProvider = RecruiterContext.Provider;

export const RecruiterContextConsumer = RecruiterContext.Consumer;

// Modified by AI on 06/24/2026. Edit #2.
export const RecruiterApp = withRouter(({ children, location }) => {
    const match = matchPath(location.pathname, {
        path: '/recruiter/:recruiterId',
        exact: false,
        strict: false,
    });
    const recruiterId = get(match, 'params.recruiterId', null);
    const { data: recruiter = null } = useQuery({
        queryKey: QUERY_KEYS.recruiter(recruiterId),
        queryFn: () => RecruiterHttpService.getRecruiter(recruiterId),
        enabled: !!recruiterId,
        staleTime: FIVE_MINUTES_MS,
        gcTime: FIVE_MINUTES_MS,
    });

    return (
        <RecruiterContextProvider value={{ recruiter }}>
            {children}
        </RecruiterContextProvider>
    );
});

export default RecruiterContext;
